import { Api } from '@shared-providers/api.provider';
import { Injectable } from '@angular/core';
import { Provider } from '@shared-providers/Provider';
import { LoadingService } from '@shared-services/loading.service';
import {
	IBeecloudAppointmentRating,
	IBeecloudDiscountCode,
	IBeegoAppointment,
	ICreateBeegoAppointment,
	IDeleteBeegoAppointment,
} from '@internal-models/beego-appointment.model';
import { encodeQueryUrl } from '@shared-libs/helpers';
import { IDataQuery, ITableData } from '@beego/ngx-table';

@Injectable({
	providedIn: 'root',
})
export class BeegoAppointmentProvider extends Provider<IBeegoAppointment> {
	protected readonly url: string = '/beego-appointments';

	constructor(
		protected readonly api: Api,
		protected readonly loadingService: LoadingService
	) {
		super(loadingService);
	}

	public getOne(appointmentId: string): Promise<IBeegoAppointment> {
		return this.process(this.api.get(`${this.url}/${appointmentId}`)) as Promise<IBeegoAppointment>;
	}

	public getAllOfClient(clientId: string): Promise<Array<IBeegoAppointment>> {
		return this.process(this.api.get(`${this.url}/client/${clientId}`)) as Promise<Array<IBeegoAppointment>>;
	}

	public getDiscountCode(excludeCodes: Array<string>): Promise<IBeecloudDiscountCode> {
		return this.process(
			this.api.get(`${this.url}/discount-code?exclude=${JSON.stringify(excludeCodes)}`)
		) as Promise<IBeecloudDiscountCode>;
	}

	public create(appointment: ICreateBeegoAppointment): Promise<IBeegoAppointment> {
		return this.process(this.api.post(`${this.url}`, appointment)) as any as Promise<IBeegoAppointment>;
	}

	public cancel(deletedBeegoAppointment: IDeleteBeegoAppointment): Promise<void> {
		return this.process(
			this.api.delete(`${this.url}/${deletedBeegoAppointment.id}`, {
				reason: deletedBeegoAppointment.reason,
				Communication: deletedBeegoAppointment.Communication,
			})
		);
	}

	public async getAll(_query: IDataQuery, status: string): Promise<ITableData<IBeegoAppointment>> {
		_query.filter = { status, ..._query.filter };
		return this.process(this.api.get(`${this.url}?query=${encodeQueryUrl(_query)}`)) as Promise<
			ITableData<IBeegoAppointment>
		>;
	}

	public async getAllAppointmentRatings(
		query: IDataQuery
	): Promise<ITableData<IBeecloudAppointmentRating & { BeegoAppointment: IBeegoAppointment }>> {
		return this.process(
			this.api.get(`${this.url}/appointment-ratings?query=${encodeQueryUrl(query)}`)
		) as Promise<ITableData>;
	}
}
